import { yup } from '@/libs/yup';
import moment from 'moment';

export const schema = yup.object().shape(
  {
    title: yup.string().required().label('報告書の名称'),
    officeId: yup.string().label('適用事業所'),
    officeSnapshot: yup.object({
      name: yup.string(),
      postcode0: yup.string(),
      postcode1: yup.string(),
      prefectureId: yup.string(),
      city: yup.string(),
      houseNumber: yup.string(),
      building: yup.string(),
      phoneNumber0: yup.string(),
      phoneNumber1: yup.string(),
      phoneNumber2: yup.string(),
      laborInsuranceNumber0: yup.string(),
      laborInsuranceNumber1: yup.string(),
      laborInsuranceNumber2: yup.string(),
      laborInsuranceNumber3: yup.string(),
      laborInsuranceNumber4: yup.string(),
      repPositionName: yup.string(),
      repLastName: yup.string(),
      repFirstName: yup.string(),
      laborStandardsInspectionOfficeLShortName: yup.string()
    }),
    businessTypeId: yup.string().label('事業の種類'),
    startOn: yup
      .string()
      .dateFormat()
      .when('endOn', {
        is: endOn => endOn,
        then: schema => schema.required(({ label }) => `${label}の日付を入力してください`)
      })
      .label('報告期間の始点'),
    endOn: yup
      .string()
      .dateFormat()
      .when('startOn', {
        is: startOn => startOn,
        then: schema => schema.required(({ label }) => `${label}の日付を入力してください`)
      })
      .test(
        'afterStartOn',
        ({ label }) => `${label}は始点以降の日付を入力してください`,
        (value: string | undefined, context) => {
          if (!value || !context.parent.startOn) return true;
          const startOn = moment(context.parent.startOn, 'YYYY/MM/DD');
          const endOn = moment(value, 'YYYY/MM/DD');
          return endOn.isSameOrAfter(startOn);
        }
      )
      .label('報告期間の終点'),
    reportNumber: yup
      .string()
      .matches(/^\d{1,2}$/, {
        message: ({ label }) => `${label}は半角数字2文字以内で入力してください`,
        excludeEmptyString: true
      })
      .label('報告回数'),
    aggregationOfficeIds: yup.array(yup.string().required()).label('集計に含める事業所')
  },
  [['startOn', 'endOn']]
);

export type Schema = yup.InferType<typeof schema>;
